import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import itTranslation from './locales/it/translation.json';
import enTranslation from './locales/en/translation.json';

const resources = {
  it: {
    translation: itTranslation,
  },
  en: {
    translation: enTranslation,
  },
};

// Detect user's preferred language from browser or localStorage
const getInitialLanguage = (): string => {
  // Always use English as default
  return 'en';
  
  /* Original implementation with browser detection:
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && (savedLanguage === 'it' || savedLanguage === 'en')) {
    return savedLanguage;
  }
  
  // Fallback to browser language
  const browserLanguage = navigator.language.split('-')[0];
  return browserLanguage === 'it' || browserLanguage === 'en' ? browserLanguage : 'it';
  */
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    debug: false, // Set to true for debugging in development
  });

export default i18n;
